<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Contribuições' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <div class="header-name">
    <i class="fa-solid fa-money-bill-1-wave"></i>

    <ion-label>{{'Minhas contribuições' | translate}}</ion-label>
  </div>

  <ion-list *ngFor="let c of contribuicoes;">
    <ion-item class="pointer border-bottom" (click)="detalhes(c);">
      <ion-label>
        <h3>{{c.planoContas.nome}}</h3>
      </ion-label>

      <ion-note slot="end">
        <ion-icon name="arrow-forward-outline" class="icon-list"></ion-icon>
      </ion-note>
    </ion-item>
  </ion-list>
</ion-content>
